import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import { sortedPosts, formatDate } from "../content/posts";

const Blog = () => (
  <Layout>
    <Seo
      title="Yazılar – LPG, Bakım ve Araç Rehberleri"
      description="LPG dönüşümü, tank değişimi, motor yağı, çeki demiri ve araç bakımı hakkında kısa rehberler. Mahir Usta Otogaz."
      path="/blog"
    />
    <PageHero title="Yazılar" text="Müşterilerimizin en çok sorduğu konuları yazıya döktük." crumbs={[{ label: "Yazılar" }]} />
    <section className="section">
      <div className="container" style={{ maxWidth: 860 }}>
        <ul className="post-list">
          {sortedPosts.map((p) => (
            <li key={p.slug}>
              <Link to={`/blog/${p.slug}`}>
                <time dateTime={p.date}>{formatDate(p.date)}</time>
                <h3>{p.title}</h3>
                <p>{p.excerpt}</p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
    <CtaBand />
  </Layout>
);

export default Blog;
